import { render } from "./MaterialSearch.vue?vue&type=template&id=8ea9684a&scoped=true"
import script from "./MaterialSearch.vue?vue&type=script&lang=js"
export * from "./MaterialSearch.vue?vue&type=script&lang=js"

import "./MaterialSearch.vue?vue&type=style&index=0&id=8ea9684a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ea9684a"]])

export default __exports__